import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const monthWiseEarningAction = createAsyncThunk(
    'month-wise-earning',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/request-payment/month`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const monthWiseEarningSlice = createSlice({
    name: 'month-wise-earning',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(monthWiseEarningAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(monthWiseEarningAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(monthWiseEarningAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const monthWiseEarningReducer = monthWiseEarningSlice.reducer